import { isEmpty } from 'lodash';
import { QueryParameter } from '../interfaces/QueryParameter';

export const getUrlWithQueryParameters = (
  queryParams: QueryParameter[],
): string => {
  let newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
  if (!isEmpty(queryParams)) {
    newUrl += `?${queryParams
      .map((param) => `${param.key}=${encodeURIComponent(param.value)}`)
      .join('&')}`;
  }

  return newUrl;
};

export const getUrlSuffix = (queryParams: QueryParameter[]): string => {
  if (queryParams.length === 0) {
    return '';
  }

  return `?${queryParams
    .map((param) => `${param.key}=${encodeURIComponent(param.value)}`)
    .join('&')}`;
};
